import React, { useState, useEffect } from 'react';
import { CircularProgress, Paper } from '@mui/material';
import { CallCenter } from "./CallCenter";
import { SIPProvider } from "@pr0tel/react-sipjs";
import axios from "axios";
import { useSnackbar } from "../../../utils/SnackbarContext"

const WebCall = () => {
  const [webRtcCredentials, setWebRtcCredentials] = useState({
    username: '',
    password: '',
    domain: '',
    port: '',
    did: '',
    coturn: '',
    coturnusername: '',
    coturnpassword: ''
  });
  const [isLoaded, setIsLoaded] = useState(false);

  const { showSnackbar } = useSnackbar();

  async function getWebRtcCredentials(params = {}) {
    try {
      const response = await axios.get(`https://cardgarantsales.com/restapi/webrtc`, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        },
        params: params
      });
      console.log(response.data);
      setWebRtcCredentials(response.data);
      setIsLoaded(true); // Данные загружены
    } catch (error) {
      console.log(error);
      if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
  }

  useEffect(() => {
    getWebRtcCredentials();
  }, []);

  if (!isLoaded) {
    return (
      <Paper
        elevation={0}
        sx={{ p: 3, minWidth: 400, maxWidth: 500, borderRadius: 2 }}
      >
        <CircularProgress />
      </Paper>
    );
  }

  return (
    <SIPProvider
      options={{
        domain: `${webRtcCredentials.domain}:${webRtcCredentials.port}`,
        webSocketServer: `wss://${webRtcCredentials.domain}:${webRtcCredentials.port}/ws`,
      }}
    >
      <CallCenter webRtcCredentials={webRtcCredentials} />
    </SIPProvider>
  );
};

export default WebCall;
